import React, { Fragment, ReactElement } from 'react';
import core, { App } from '@gin-betting/core';
import { Arg1 } from 'tsargs';

import { MatchListType } from 'app-constants';
import Results from './Results/Results';
import Upcoming from './Upcoming/Upcoming';
import LiveList from './LiveList';
import PrematchList from './PrematchList';
import useMatchListContainer from './useMatchListContainer';

const {
    poller: { usePoller },
} = core;

interface Props {
    type: MatchListType;
    fetchStatus: App.FetchStatus;
    pollerOpts: Arg1<typeof usePoller>;
}

const MATCH_LIST_COMPONENTS_BY_TYPE: Record<MatchListType, ReactElement> = {
    [MatchListType.LIVE]: <LiveList />,
    [MatchListType.RESULTS]: <Results />,
    [MatchListType.UPCOMING]: <Upcoming />,
    [MatchListType.PREMATCH]: <PrematchList />,
};

const MatchListContainer: React.FC<Props> = ({ pollerOpts, type }) => {
    const { shouldRenderMatchList } = useMatchListContainer({
        pollerOpts,
        type,
    });

    return (
        <Fragment>
            {shouldRenderMatchList && MATCH_LIST_COMPONENTS_BY_TYPE[type]}
        </Fragment>
    );
};

export default MatchListContainer;
